export default __webpack_public_path__ + "static/media/React18.e46e2645.png";